import DataProvider from "./DataProvider";

export default DataProvider;